import { render, staticRenderFns } from "./HomeDepositMethods.vue?vue&type=template&id=7b6ed1b6&scoped=true"
import script from "./HomeDepositMethods.vue?vue&type=script&lang=js"
export * from "./HomeDepositMethods.vue?vue&type=script&lang=js"
import style0 from "./HomeDepositMethods.vue?vue&type=style&index=0&id=7b6ed1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ed1b6",
  null
  
)

export default component.exports